import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-subject-attendance-flex',
  templateUrl: './subject-attendance-flex.component.html',
  styleUrls: ['./subject-attendance-flex.component.scss']
})
export class SubjectAttendanceFlexComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private dataService: DataService) { }

  slotId: any = 0;
  slot: any = {
    batch: { course: {}, start_year: '', end_year: '', current_semester: '' },
    slot_date: '',
    start_time: '',
    end_time: '',
    subject: '',
    topic_id: 0,
    faculty: { name: '' }
  };
  students: any = { list: [], count: 0 };
  limit: any = 30;
  offset: any = 0;
  search: any = "";
  loading: any = false;
  date: any = "";
  today: any = "";
  attendance: any = [];
  isHoliday: any = false;
  sessionType: string = 'theory'; // Default to theory

  ngOnInit(): void {
    this.slotId = this.route.snapshot.paramMap.get('slotId');
    this.date = new Date();
    this.today = new Date();

    this.loadSlot();
  }

  loadSlot() {
    this.dataService.getFlexSlotInfo(this.slotId).subscribe((data: any) => {
      if (data.status == 0) {
        this.slot = data.slot;
        // Set date to slot date by default
        this.date = new Date(this.slot.slot_date);
        this.loadStudents(this.slot.batch.id);
        this.loadAttendance();
      } else {
        alert(data.msg);
      }
    });
  }

  loadStudents(batchId) {
    this.dataService.getStudents(this.limit, this.offset, this.search, batchId).subscribe((data: any) => {
      if (data.status == 0) {
        this.students = data;
      }
    });
  }

  paginate(dir) {
    if (dir == 2) {
      this.offset += this.limit;
    } else {
      this.offset -= this.limit;
      if (this.offset < 0) {
        this.offset = 0;
      }
    }

    this.loadStudents(this.slot.batch.id);
  }

  formattedDate(date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
    return formattedDate;
  }

  forwardDate() {
    const nextDate = new Date(this.date);
    nextDate.setDate(nextDate.getDate() + 1);
    this.date = nextDate;
    this.loadAttendance();
  }

  backwardDate() {
    const previousDate = new Date(this.date);
    previousDate.setDate(previousDate.getDate() - 1);
    this.date = previousDate;
    this.loadAttendance();
  }

  setCustomDate(date) {
    this.date = new Date(date);
    this.loadAttendance();
  }

  loadAttendance() {
    this.attendance = {};
    this.dataService.getFlexSubjectAttendance(this.slotId, this.formattedDate(this.date)).subscribe((data: any) => {
      if (data.status == 0) {
        this.attendance = data.data;
        this.isHoliday = data.isHoliday;
        // Load session type if it exists
        this.sessionType = data.session_type || 'theory';
      }
    });
  }

  markAttendance(studentId, attendance) {
    if (!this.attendance[studentId]) {
      this.attendance[studentId] = {};
    }

    let data = {
      student_id: studentId,
      attendance: attendance,
      date: this.formattedDate(this.date),
      slot_id: this.slotId,
      topic_id: this.slot.topic_id,
      session_type: this.sessionType
    }
    this.attendance[studentId] = attendance;
    this.loading = true;
    this.dataService.postFlexSubjectAttendance(data).subscribe((res: any) => {
      this.loading = false;
      if (res.status == 0) {
        //
      } else {
        alert(res.msg);
      }
    });
  }

  setSessionType(type: string) {
    this.sessionType = type;
  }

}
